import { createElement } from 'react';
import { Table as OriginalTable } from 'antd';
const Table = (props) => {
    const columns = (props.columns || []).filter((item) => !item?.hidden);
    return createElement(OriginalTable, Object.assign({}, props, { columns: columns }));
};
Table.displayName = 'Table';
export default Table;
